import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Grid, Typography, Button, Skeleton, Divider } from '@mui/material';
import { AttachMoney, Visibility, VisibilityOff } from '@mui/icons-material';
import { ProventosDescontosFerias, DetalhesFeriasCard } from './components';
import { colaboradorService } from '@core/services';
import { selectorDetalheFerias } from '@core/slice/detalheFerias.slice';
import { AlertComponent } from '@core/components/atoms/alert-component';
import { useAppSelector } from '@store/hooks';

import { formatCurrency, formatDate, getDateFromSap } from '@core/utils';

interface IDetalhesFeriasProps {}

export const DetalhesFerias: React.FC<IDetalhesFeriasProps> = () => {
    const { inicioPeriodo, inicioFerias, diasProgramados, diasAbono, adiantamento13, descricaoStatus } = useParams<{
        inicioPeriodo?: string;
        inicioFerias?: string;
        diasProgramados?: string;
        diasAbono?: string;
        adiantamento13?: string;
        descricaoStatus?: string;
    }>();

    const { data, loading, error } = useAppSelector(selectorDetalheFerias);

    useEffect(() => {
        if (inicioPeriodo && inicioFerias) {
            colaboradorService.detalheFerias(inicioPeriodo, inicioFerias);
        }
    }, []);
    const [showValues, setShowValues] = useState(false);

    return (
        <Container maxWidth="xl">
            <Grid>
                <DetalhesFeriasCard
                    dataInicio={data.inicioFerias}
                    diasProgramados={Number(diasProgramados)}
                    diasAbono={Number(diasAbono)}
                    adiantamento13={adiantamento13 ?? ''}
                    descricaoStatus={descricaoStatus ?? ''}
                />
                <Grid sx={{ marginTop: '1rem' }}>
                    <Typography>Valor liquido</Typography>
                    <Grid sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        {showValues ? (
                            <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }} data-clarity-mask="true">
                                {formatCurrency(Number(data.valorLiquido ?? 0))}
                            </Typography>
                        ) : (
                            <Skeleton variant="rounded" animation={false} width="6rem" height="1rem" />
                        )}
                        <Button onClick={() => setShowValues(!showValues)}>{showValues ? <Visibility sx={{ cursor: 'pointer' }} /> : <VisibilityOff sx={{ cursor: 'pointer' }} />}</Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid sx={{ marginTop: '1rem' }}>
                <Typography sx={{ fontWeight: 'bold' }}>Pago em {formatDate(getDateFromSap(data.inicioFerias), false)}</Typography>

                {/* Proventos */}
                <Grid sx={{ marginTop: '1rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Grid
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}
                    >
                        <AttachMoney style={{ color: 'green' }} />
                        <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>Proventos</Typography>
                    </Grid>
                    {showValues ? (
                        <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }} data-clarity-mask="true">
                            {formatCurrency(data.valorProventos ?? 0)}
                        </Typography>
                    ) : (
                        <Skeleton variant="rounded" animation={false} width="6rem" height="1rem" />
                    )}
                </Grid>
                <Divider sx={{ mt: '0.5rem', mb: '1rem' }} />
                <Grid sx={{ marginLeft: '1.6rem', display: 'flex', flexDirection: 'column' }}>
                    {error && !loading ? (
                        <AlertComponent type="error" detailed={true} message={error ?? '-'} />
                    ) : (
                        <>
                            {data.proventos && !loading ? (
                                data.proventos.map((provento, index) => <ProventosDescontosFerias key={index} data={provento} showValues={showValues} />)
                            ) : !loading ? (
                                <AlertComponent type="info" detailed={true} message="Lista de proventos indisponível." />
                            ) : (
                                ''
                            )}
                        </>
                    )}
                </Grid>

                {/* Descontos */}
                <Grid sx={{ marginTop: '1rem', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Grid
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}
                    >
                        <AttachMoney style={{ color: 'red' }} />
                        <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>Descontos</Typography>
                    </Grid>
                    {showValues ? (
                        <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }} data-clarity-mask="true">
                            {formatCurrency(data.valorDescontos ?? 0)}
                        </Typography>
                    ) : (
                        <Skeleton variant="rounded" animation={false} width="6rem" height="1rem" />
                    )}
                </Grid>
                <Divider sx={{ mt: '0.5rem', mb: '1rem' }} />
                <Grid sx={{ marginLeft: '1.6rem', display: 'flex', flexDirection: 'column' }}>
                    {error && !loading ? (
                        <AlertComponent type="error" detailed={true} message={error ?? '-'} />
                    ) : (
                        <>
                            {data.descontos && !loading ? (
                                data.descontos.map((desconto, index) => <ProventosDescontosFerias key={index} data={desconto} showValues={showValues} />)
                            ) : !loading ? (
                                <AlertComponent type="info" detailed={true} message="Lista de descontos indisponível." />
                            ) : (
                                ''
                            )}
                        </>
                    )}
                </Grid>
            </Grid>
        </Container>
    );
};
